import React, { useEffect, useState } from "react";
import { getHero } from "../api/companyService";
import { sleep } from "../utils/sleep";

const Hero = () => {
  
  const [currentHeroIndex, setCurrentHeroIndex] = useState(0);
  //const [hero, setHero] = useState([]);
  const [hero, setHero] = useState({
    messages: [""],
    bgColor: "#5B7C99",
  });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
  
    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentHeroIndex((prev) => (prev + 1) % hero.messages.length);
      }, 3000);
      return () => clearInterval(interval);
    }, [hero.messages]);
  
      useEffect(() => {
      const fetchHero = async () => {
        try {
          // simulate network delay (3 sec)
          //await sleep(3000);
  
          const data = await getHero(); // asynchronous call
          setHero(data);
        } catch (err) {
          setError("Failed to load hero.");
        } finally {
          setLoading(false);
        }
      };
  
      fetchHero();
      }, []);
    
   
    
     // Error Message
    if (error) {
      return (
        <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
          <p className="text-danger fs-7">{error}</p>
          <button
            className="btn btn-outline-primary mt-3"
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      );
  }
  
  return (
    <section className="text-white text-center p-5 hero-section position-relative" style={{ backgroundColor: hero.bgColor }}>
      {(loading || error) ? (
        <div className="container">
          <h1 className="display-4 animated-text fade-in fw-bold placeholder-glow">
            <span className="placeholder col-4 nav-placeholder">&nbsp;</span>
          </h1>
          <p className="lead placeholder-glow">
             <span className="placeholder col-3 nav-placeholder">&nbsp;</span>
          </p>
          <p className="mt-3 placeholder-glow">
             <span className="placeholder col-1 nav-placeholder">&nbsp;</span>
          </p>
        </div>
          ) : (
           
        <div className="container">
          <h1 className="display-4 animated-text fade-in fw-bold">
            {hero.messages[currentHeroIndex]}
                  </h1>
            <p className="lead">{hero.description}</p>
          <a href={hero.link} className="btn mt-3 bg-primary-color text-secondary-color">{hero.linkText}</a>

          {/* Slide Indicators */}
          <div className="slide-indicators mt-4">
            {hero.messages.map((_, index) => (
              <span
                key={index}
                className={`indicator-dot ${index === currentHeroIndex ? 'active' : ''}`}
              ></span>
            ))}
          </div>
        </div>
          )}
        
      </section>
  );
};

export default Hero;
